import { object, string } from 'yup';

// Luhn algorithm Check
const LuhnAlgoritmCheck = (value: string) => {
  // Accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(value)) {
    return false;
  }

  // The Luhn Algorithm.
  let nCheck = 0;
  let bEven = false;
  const parameter = value.replace(/\D/g, '');

  for (let n = parameter.length - 1; n >= 0; n -= 1) {
    const cDigit = parameter.charAt(n);
    let nDigit = parseInt(cDigit, 10);

    // eslint-disable-next-line no-cond-assign
    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 === 0;
};

export const initialValues = {
  acardNumber: '',
  amount: '',
  remark: '',
};

export const validationSchema = object().shape({
  acardNumber: string().test(
    'is-correct',
    'acard.transfer.add.form.field.acardnumber.error.format',
    async (value: string | undefined, testContext) => {
      if (value) {
        if (!value.startsWith('9000')) {
          return false;
        }

        if (!LuhnAlgoritmCheck(value)) {
          return false;
        }

        return true;
      }

      return testContext.createError({
        message: 'acard.transfer.add.form.field.acardnumber.error.format',
      });
    },
  ),
  cheque: string().required('acard.transfer.add.form.field.cheque.error.required'),
  remark: string(),
});
